/**
 * Slug organisasi dari nama yang diketik orang — DUPLIKASI SENGAJA dari `apps/web/src/pages/
 * OnboardingPage.tsx` (CRM), bukan diimpor lintas-app (dua app terpisah, fungsi murni sekecil
 * ini tidak sepadan dipaketkan bersama — pola sama `demo-cooldown.ts` sebelumnya).
 *
 * HARUS cocok validasi backend (`OnboardingDto.slug`, `apps/api/src/modules/onboarding/
 * onboarding.dto.ts`): huruf kecil + angka + tanda hubung, 2–63 karakter. Dibuat di sisi klien
 * cuma untuk kenyamanan default (field slug tetap bisa diubah manual) — validasi SEBENARNYA tetap
 * di server, fungsi ini tidak pernah jadi satu-satunya penjaga.
 */
export function slugify(nama: string): string {
  return nama
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63);
}
